<ng-container *transloco="let t">
    <div class="card" *ngIf="escalation">
        <div class="card-header">
          {{ t('Edit your Escalation Procedure') }}
        </div>
        <div class="card-body">
            <p>{{ t('We will now help you build up your escalation procedure.') }}</p>

            <c-row>
                <c-col class="col-lg-6 col-12">
                    <p>{{ t('What would you like the next step to be, if the previous step fails...') }}</p>

                    <button type="button" class="btn btn-outline-primary m-1" (click)="newStep('phonecall')"><i class="fa-solid fa-plus"></i>{{ t(' Make a Phonecall') }}</button>
                    <button type="button" class="btn btn-outline-primary m-1" (click)="newStep('location')"><i class="fa-solid fa-plus"></i>{{ t(' Send Location') }}</button>
                    <button type="button" class="btn btn-outline-primary m-1" (click)="newStep('custom')"><i class="fa-solid fa-plus"></i>{{ t(' Custom Step') }}</button>

                    <div class="alert alert-warning" role="alert" *ngIf="step.error">
                        {{step.error}}
                    </div>



                    <ng-container *ngIf="step.type == 'custom'">

                      <div class="card">
                        <div class="card-body">
                        <form  cForm>


                            <div class="mb-3">
                              <label for="exampleFormControlTextarea1" class="form-label" >{{ t('Enter a custom step for the escalation procedure') }}</label>
                              <textarea class="form-control"  rows="4" name="custom" [(ngModel)]="step.values.custom"></textarea>
                            </div>


                            <c-row>
                              <c-col class="mt-3">
                                <button cButton class="px-4 text-white btn-info" type="submit" (click)="submitStep()">
                                  <i class="fa-solid fa-check"></i> {{ t('Save') }}
                                </button>
                                <button cButton class="px-4" color="light" type="submit" (click)="cancelStep()">
                                  <i class="fa-solid fa-times"></i> {{ t('Cancel') }}
                                </button>
                              </c-col>
                            </c-row>
                          </form>
                        </div>
                      </div>

                    </ng-container>
                    <ng-container *ngIf="step.type == 'location'">

                      <div class="card">
                        <div class="card-body">
                        <form  cForm>

                          <div class="mb-3">
                            <label  class="form-label">{{ t('What is the location they should be sent too?') }}</label>
                            <input type="text" class="form-control"  name="location" placeholder="Location" [(ngModel)]="step.values.location" [disabled]="step.values.last_known">
                          </div>

                          <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="form_last_known" name="last_known" [(ngModel)]="step.values.last_known" >
                            <label for="form_last_known" class="form-check-label" for="flexCheckDefault">
                              {{ t('Visit last known location (will enter the workers details automatically)') }}
                            </label>
                          </div>

                          <div class="mb-3">
                            <label  class="form-label">{{ t('Who should visit, and their contact details') }}</label>
                            <input type="text" class="form-control"  name="who" placeholder="{{ t('Who') }}"
                            [(ngModel)]="step.values.who">
                          </div>

                            <div class="mb-3">
                              <label  class="form-label" >{{ t('Enter some notes about what to do when they arrive at the location') }}</label>
                              <textarea class="form-control"  rows="4" name="notes" [(ngModel)]="step.values.notes"></textarea>
                            </div>

                            <c-row>
                              <c-col class="mt-3">
                                <button cButton class="px-4 text-white btn-info" type="submit" (click)="submitStep()">
                                  <i class="fa-solid fa-check"></i> {{ t('Save') }}
                                </button>
                                <button cButton class="px-4" color="light" type="submit" (click)="cancelStep()">
                                  <i class="fa-solid fa-times"></i> {{ t('Cancel') }}
                                </button>
                              </c-col>
                            </c-row>
                          </form>
                        </div>
                      </div>

                    </ng-container>
                    <ng-container *ngIf="step.type == 'phonecall'">

                      <div class="card">
                        <div class="card-body">
                      <form  cForm>

                        <c-row>
                          <c-col>
                            <div class="mb-3">
                              <label  class="form-label">{{ t('Who do you want to contact?') }}</label>
                              <input type="text" class="form-control"  name="contact_name" placeholder="{{ t('Contact name') }}" [(ngModel)]="step.values.contact_name" [disabled]="step.values.call_worker || step.values.call_worker_alt">
                            </div>

                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" id="form_call_worker" name="call_worker" [(ngModel)]="step.values.call_worker" >
                              <label for="form_call_worker" class="form-check-label" for="flexCheckDefault">
                                {{ t('Call the worker who has missed their check-in or sent a help alert using the details in their profile.') }}
                              </label>
                            </div>

                          </c-col>
                          <c-col>
                            <div class="mb-3">
                              <label  class="form-label">{{ t('What is their phone number?') }}</label>
                              <input type="text" class="form-control"  name="contact_number" placeholder="{{ t('Contact number') }}" [(ngModel)]="step.values.contact_number" [disabled]="step.values.call_worker || step.values.call_worker_alt">
                            </div>

                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" id="form_call_worker_alt" name="call_worker_alt" [(ngModel)]="step.values.call_worker_alt" >
                              <label for="form_call_worker_alt" class="form-check-label" for="flexCheckDefault">
                                {{ t("Use worker's alternative number for this step (this step will only appear if they have an alternative number).") }}
                              </label>
                            </div>

                          </c-col>
                        </c-row>

                        <div class="mb-3">
                          <label  class="form-label" >{{ t('If no answer, what voicemail messages shall we leave?') }}</label>
                          <textarea class="form-control"  rows="2" name="voicemail" [(ngModel)]="step.values.voicemail"></textarea>
                        </div>

                        <c-row>
                          <c-col>
                            <div class="mb-3">
                              <label  class="form-label">{{ t('How many times should we try call if no answer?') }}</label>
                              <select class="form-select"  name="call_times" [(ngModel)]="step.values.call_times">
                                <option value="1">{{ t('One') }}</option>
                                <option value="2">{{ t('Two') }}</option>
                                <option value="3">{{ t('Three') }}</option>
                              </select>
                            </div>
                          </c-col>
                          <c-col>
                            <div class="mb-3">
                              <label  class="form-label">{{ t('How long do you want us to wait between each call?') }}</label>
                              <select class="form-select"  name="wait_time" [(ngModel)]="step.values.wait_time">
                                <option value="1">{{ t('One minute') }}</option>
                                <option value="2">{{ t('Two minutes') }}</option>
                                <option value="3">{{ t('Three minutes') }}</option>
                                <option value="4">{{ t('Four minutes') }}</option>
                                <option value="5">{{ t('Five minutes') }}</option>
                              </select>
                            </div>
                          </c-col>
                        </c-row>


                          <div class="mb-3">
                            <label  class="form-label" >{{ t("Are there any other notes you'd like to include for this person?") }}</label>
                            <textarea class="form-control"  rows="4" name="notes" [(ngModel)]="step.values.notes"></textarea>
                          </div>

                          <c-row>
                            <c-col class="mt-3">
                              <button cButton class="px-4 text-white btn-info" type="submit" (click)="submitStep()">
                                <i class="fa-solid fa-check"></i> {{ t('Save') }}
                              </button>
                              <button cButton class="px-4" color="light" type="submit" (click)="cancelStep()">
                                <i class="fa-solid fa-times"></i> {{ t('Cancel') }}
                              </button>
                            </c-col>
                          </c-row>
                        </form>
                      </div>
                    </div>

                  </ng-container>

                </c-col>
                <c-col class="col-lg-6 col-12 text-center">
                    <button cButton class="px-4 mb-3 text-white btn-info" type="submit" (click)="endEditing()">
                        <i class="fa-solid fa-check"></i> {{ t('Finish Editing the Escalation') }}
                      </button>

                      <div class="card text-start">
                        <ul class="list-group list-group-flush">

                      <ng-container  *ngFor="let step of steps, let i = index">
                        <li class="list-group-item">
                          <div class="float-end">
                            <div class="btn-group" role="group" aria-label="...">
                              <button class="btn btn-outline-secondary" role="button" (click)="removeStep(i)" *ngIf="steps.length > 1"><i class="fa fa-times" aria-hidden="true"></i></button>
                              <button class="btn btn-outline-secondary" role="button"  (click)="swap(steps,i,(i-1))" *ngIf="i > 0"><i class="fa fa-arrow-up" aria-hidden="true"></i></button>
                              <button class="btn btn-outline-secondary" role="button" (click)="swap(steps,i,(i+1))" *ngIf="i < steps.length - 1"><i class="fa fa-arrow-down" aria-hidden="true"></i></button>
                              <button class="btn btn-outline-secondary" role="button" (click)="setEditStepForm(step,i)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                            </div>
                          </div>

                          <div [innerHtml]="steps_html[i]">{{i}}</div>

                        </li>
                      </ng-container>

                    </ul>
                  </div>

                </c-col>
              </c-row>

        </div>
      </div>


<!-- Modal -->
<div class="modal fade" id="editStepModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="editStepModalLabel">{{ t('Edit the Step') }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form>

            <button cButton class="px-4 text-white btn-info" type="submit">
              <i class="fa-solid fa-check"></i>{{ t(' Update Step') }}
            </button>
        </form>
      </div>
    </div>
  </div>
</div>

</ng-container>
